import React from 'react';
import moment from 'moment';
import ui from '../../common/services/ui';

function findLesson(childId, lessonDate, childLessons) {
	const sameDay = (a, b) => moment(a).startOf('day').isSame(moment(b).startOf('day'));
	return (
		childLessons.find(l => l.child.id === childId && sameDay(l.lessonDate, lessonDate) && l.lessonType === 1) ||
		childLessons.find(l => l.child.id === childId && sameDay(l.lessonDate, lessonDate) && l.lessonType === 2) ||
		childLessons.find(l => l.child.id === childId && sameDay(l.lessonDate, lessonDate) && l.lessonType === 3) ||
		null
	);
}

function getUniqueChildrenSorted(childLessons) {
	const sortByName = arr => arr.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1);

	const normalChildIds = new Set(
		childLessons.filter(l => l.lessonType === 1).map(l => l.child.id)
	);

	const normalChildren = new Map();
	const otherChildren = new Map();

	childLessons.forEach(lesson => {
		const id = lesson.child.id;
		if (lesson.lessonType === 1) {
			normalChildren.set(id, lesson.child);
		} else if (!normalChildIds.has(id)) {
			otherChildren.set(id, lesson.child);
		}
	});

	return [
		...sortByName(Array.from(normalChildren.values())),
		...sortByName(Array.from(otherChildren.values()))
	];
}

const PrintView = ({ weeklyProgramItem, childLessons, lessonDates, enableCollectMedicalInformation, t }) => {
	if (!childLessons || !lessonDates) return null;

	const children = getUniqueChildrenSorted(childLessons);

	const renderHeader = () => {
		if (!weeklyProgramItem) return null;
		const { center, term, grade, weekday, startTime, endTime } = weeklyProgramItem;
		const timeframe = `${ui.formatTime(startTime)} - ${ui.formatTime(endTime)}`;
		const weekdayName = t(ui.days[weekday]);
		return (
			<div className='print-header'>
				<p style={{ margin: '0 0 3px 0', fontSize: '10pt' }}>
					<strong>{center && center.name}</strong>
					{' · '}
					{term && term.name}
					{' · '}
					{grade && grade.name}
					{' · '}
					{weekdayName}
					{' · '}
					{timeframe}
				</p>
				<p style={{ margin: '0 0 10px 0', fontSize: '9pt', color: '#555' }}>
					{t('Attendance_PrintedOn')}: {moment().format('LL')}
				</p>
			</div>
		);
	};

	return (
		<div className='print-only'>
			{renderHeader()}
			<table className='print-attendance-table'>
				<thead>
					<tr>
						<th>#</th>
						<th style={{ maxWidth: 200 }}>{t('Child_FullName')}</th>
						{lessonDates.map(date => (
							<th key={date} className='center' style={{ whiteSpace: 'nowrap' }}>
								{ui.customDateFormat(date, 'D MMM')}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{children.map((child, index) => (
						<tr key={child.id}>
							<td style={{ width: 30 }}>{index + 1}</td>
							<td style={{ maxWidth: 200, wordBreak: 'break-word' }}>
								<span style={{ whiteSpace: 'nowrap' }}>
									<strong>{child.name}</strong>
									{' '}
									<span style={{ fontWeight: 'normal', fontSize: '9pt', color: '#555' }}>
										{ui.formatAge(child.dateOfBirth)}
									</span>
								</span>
								{child.parent && <div style={{ fontSize: '9pt', color: '#555', whiteSpace: 'nowrap' }}>{child.parent.name}</div>}
								{enableCollectMedicalInformation && child.hasAnyMedicalInformation && (
									<div style={{ fontSize: '8pt', color: '#c00', marginTop: 2 }}>
										{child.medicalConditions && child.medicalConditions.length > 0
											? child.medicalConditions.join(', ')
											: t('Child_HasMedicalInformationWithIssuesTooltip')
										}
									</div>
								)}
							</td>
							{lessonDates.map(date => {
								const lesson = findLesson(child.id, date, childLessons);
								if (!lesson) {
									return <td key={date} className='center' style={{ color: '#bbb' }}>—</td>;
								}
								return (
									<td key={date} className='center' style={{ fontSize: '14pt' }}>
										{'☐'}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
			<p style={{ fontSize: '9pt', marginTop: 8, color: '#555' }}>
				{t('Attendance_Print_Total')}: {children.length}
			</p>
		</div>
	);
};

export default PrintView;
